import PatientRouter from "@/router/PatientRouter";
import ProviderRouter from "@/router/ProviderRouter";
import AdminRouter from "@/router/AdminRouter";
import { getPortalHost } from "@/utils/portalHost";

const AppRouter = () => {
  const portal = getPortalHost();

  if (portal === "provider") {
    return <ProviderRouter />;
  }

  if (portal === "admin") {
    return <AdminRouter />;
  }

  return <PatientRouter />;
};

export default AppRouter;

